import React, { useState } from "react";
import { Col, Form, Image, Modal, Row, Table } from "react-bootstrap";
import { cancelTicketRequested } from "app/services/AdminServices/bookingService";
import { Button } from "react-bootstrap";
import moment from "moment";
import { Formik } from "formik";
import { NotificationManager } from "react-notifications";
import {
  RenderCheckboxInput,
  RenderTextArea,
  RenderTextInput,
} from "app/common/renderInput";

export default function ApproveCancel({
  // submitCancelHandeler,
  setShow,
  initialValues,
  validationSchema,
  show,
  handleClose,
  loadChangeRequest,
}) {
  const [isShow, setIsShow] = useState(false);
  debugger
  //console.log("From ApproveCancel:", initialValues);
//console.log("reviewApiResponse:", initialValues?.reviewApiResponse);
 //var reviewdata = JSON.parse(initialValues)
   //console.log("form approveCancel",initialValues);



  const submitCancelHandler = async (values) => {
    debugger;
    let cancelBookingReq = {};
    cancelBookingReq.requestType = "CANCEL_TICKET";
    cancelBookingReq.bookingDetailId = values.id;
    cancelBookingReq.remarks = values.remarks;
    cancelBookingReq.cancellationCharges = values.cancellationCharges;
    cancelBookingReq.isRefund = values.isRefund == true ? true : false;
    cancelBookingReq.refundAmount = values.refundAmount;
    cancelBookingReq.dateOfJourney = "";
    cancelBookingReq.bookedPassengerList = [];
    values.changePassengerList
      .filter((x) => x.selected)
      .forEach((item) => {
        let passengerCancel = {
          passangerId: item.id,
          passengerType: item.passengerType,
          title: item.title,
          firstName: item.firstName,
          lastName: item.lastName,
          gender: item.gender,
          birthDate: item.birthDate,
        };
        cancelBookingReq.bookedPassengerList.push(passengerCancel);
      });
      debugger
    //console.log(cancelBookingReq);
    setIsShow(true);
    const submitData = await cancelTicketRequested(cancelBookingReq);
    //console.log(submitData);
    try {
      if (submitData.data.status == "Success") {
        NotificationManager.success(submitData.data.message);
        setTimeout(() => {
          setIsShow(false);
          setShow(false);
        }, 3000);
      } else {
        NotificationManager.error(submitData.data.message);
        setIsShow(false);
        setShow(false);
      }
      setTimeout(async () => {
        await loadChangeRequest();
      }, 10);
    } catch (error) {
      NotificationManager.error(error);
      setIsShow(false);
      setShow(false);
    }
    
  };
  return (
    <div>
      <Modal
        scrollable="inside"
        size="xl"
        show={show}
        onHide={handleClose}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            <label className="text-dark text-bold">Cancel Ticket Request</label>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="table table-striped">
            <thead className="bg-primary text-white  ">
              <tr style={{ textAlign: "center" }}>
                <th scope="col">Airline Name</th>
                <th scope="col">Departure Time</th>
                <th scope="col">Source</th>
                <th scope="col">Arrival Time</th>
                <th scope="col">Destination</th>
                <th scope="col">PNR</th>
                <th scope="col">Journey Type</th>
                <th scope="col">Booked Fare</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ textAlign: "center" }}>
                <td>
                  {" "}
                  <Image
                    src={`/assets/images/airlineLogo/${initialValues?.flightCarrier?.flightcarrierCode}.gif`}
                    alt=""
                    height="22"
                    width={"22"}
                    style={{ marginRight: 5 }}
                  />
                  {initialValues?.flightCarrier?.flightCarrierName}
                </td>

                <td>
                  {moment(initialValues?.departureDate).format(
                    "DD-MM-YYYY hh:mm a"
                  )}
                </td>
                <td>
                  {initialValues?.airportDeparture?.cityName} (
                  {initialValues?.airportDeparture?.cityCode})
                </td>
                <td>
                  {moment(initialValues?.arrivalDate).format(
                    "DD-MM-YYYY hh:mm a"
                  )}
                </td>
                <td>
                  {initialValues?.airportDestination?.cityName} (
                  {initialValues?.airportDestination?.cityCode})
                </td>
                <td>{initialValues?.pnr}</td>

                <td>
                  {initialValues?.isDomestic == true
                    ? "Domestic"
                    : "International"}{" "}
                  {initialValues?.journeyType == 1 ? "Oneway" : "Return"}
                </td>
                {/* <td>₹ {Number(initialValues?.refundFare).toFixed(2)}</td> */}
                 <td>₹ {Number(initialValues?.netTotalFare).toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={submitCancelHandler}
            enableReinitialize={true}
          >
            {({
              values,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              isValid,
              dirty,
              touched,
              setFieldValue,
            }) => {
              return (
                <form
                  className="needs-validation"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  <div className="row">
                    <Table>
                      <thead style={{ textAlign: "center" }}>
                        <tr>
                          <th></th>
                          <th>Title</th>
                          <th>First Name</th>
                          <th>Last Name</th>
                          {/* <th>Date of Birth</th> */}
                        </tr>
                      </thead>

                      {values.changePassengerList.map((item, index) => {
                        return (
                          <tbody key={index}>
                            <tr>
                              <td>
                                <div className="row input-group-md m-2">
                                  <input
                                    name={`changePassengerList[${index}].selected`}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={
                                      values.changePassengerList[index].selected
                                    }
                                    type="checkbox"
                                  />
                                </div>
                              </td>
                              <td style={{ width: "10%" }}>
                                {" "}
                                <div className="row input-group input-group-md">
                                  <input
                                    name={`changePassengerList[${index}].title`}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={
                                      values.changePassengerList[index]?.title
                                    }
                                    type="text"
                                    className="form-control input-group-md"
                                    aria-describedby="basic-addon1"
                                    readOnly
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="row input-group input-group-md  ">
                                  <input
                                    name={`changePassengerList[${index}].firstName`}
                                    value={
                                      values.changePassengerList[index]
                                        .firstName
                                    }
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    type="text"
                                    className="form-control input-group-md"
                                    placeholder="First Name "
                                    aria-label="Username"
                                    aria-describedby="basic-addon1"
                                    readOnly
                                  />
                                </div>
                              </td>
                              <td>
                                {" "}
                                <div className="row input-group input-group-md">
                                  <input
                                    name={`changePassengerList[${index}].lastName`}
                                    value={
                                      values.changePassengerList[index].lastName
                                    }
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    type="text"
                                    className="form-control input-group-md"
                                    placeholder="Last Name"
                                    aria-label="Username"
                                    aria-describedby="basic-addon1"
                                    readOnly
                                  />
                                </div>
                              </td>
                              {/* <td>
                                {" "}
                                <div className="row input-group input-group-md ">
                                  <input
                                    type="date"
                                    className="form-control"
                                    name={`changePassengerList[${index}]. `}
                                    value={
                                      values.changePassengerList[index]
                                        .birthDate
                                        ? new moment(
                                            values.changePassengerList[
                                              index
                                            ].birthDate,
                                            "DD-YYYY-MM"
                                          ).format("YYYY-MM-DD")
                                        : ""
                                    }
                                    max={moment().format("YYYY-MM-DD")}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    aria-label="Username"
                                    aria-describedby="basic-addon1"
                                    readOnly
                                  />
                                </div>
                              </td> */}
                            </tr>
                          </tbody>
                        );
                      })}
                    </Table>
                    {/* {JSON.stringify(console.log(initialValues))} */}
                    <Row className="mb-2">
                      <Col>
                        <Form.Check
                          label={
                            <span
                              style={{
                                fontWeight: "bold",
                                color: "green",
                              }}
                            >
                              Refund Now
                            </span>
                          }
                          type="checkbox"
                          checked={values.isRefund}
                          value={values.isRefund}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.isRefund}
                          name="isRefund"
                          id="isRefund"
                        />
                      </Col>
                    </Row>

                    <div>
                      <Row>
                        <Col>
                          <RenderTextInput
                            type="number"
                            name="cancellationCharges"
                            display="Admin Cancellation Charges"
                            placeholder="Admin Cancellation Charges"
                            value={values.cancellationCharges}
                            error={errors.cancellationCharges}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.cancellationCharges}
                            required
                          ></RenderTextInput>
                        </Col>

                        <Col>
                          <RenderTextInput
                            type="number"
                            name="refundAmount"
                            display="Flight Cancellation Amount"
                            placeholder="Flight Cancellation Amount"
                            value={values.refundAmount}
                            error={errors.refundAmount}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.refundAmount}
                            required
                          ></RenderTextInput>
                        </Col>
                        <Col
                          style={{
                            color:
                              values.refundAmount &&
                              values.cancellationCharges &&
                              "red",
                            // fontWeight: "600",
                          }}
                        >
                          <label>Agent Refund Amount</label>
                          <input
                            style={{
                              color: "red",
                              fontWeight: "600",
                              border:
                                (values.refundAmount ||
                                  values.cancellationCharges) &&
                                "1px solid red", // Red border
                              borderRadius: "4px", // Optional: Add rounded corners
                            }}
                            className="form-control"
                            readOnly
                            type="number"
                            // name=""

                            placeholder="Agent Refund Amount"
                            value={
                              initialValues?.netTotalFare ||
                              (values.refundAmount &&
                                values.cancellationCharges)
                                ? Number(
                                    initialValues?.netTotalFare -
                                      values.refundAmount -
                                      values.cancellationCharges
                                  ).toFixed(2)
                                : ""
                            }
                            //------New changed code------
                            //  value={
                            //   initialValues?.refundFare ||
                            //   (values.refundAmount &&
                            //     values.cancellationCharges)
                            //     ? Number(
                            //         initialValues?.refundFare -
                            //           values.refundAmount -
                            //           values.cancellationCharges
                            //       ).toFixed(2)
                            //     : ""
                            // }
                            //------------

                          ></input>
                        </Col>
                      </Row>

                      <RenderTextArea
                        type="text"
                        name="remarks"
                        display="Remarks"
                        placeholder="Remarks"
                        value={values.remarks}
                        error={errors.remarks}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        touched={touched.remarks}
                        // required
                      ></RenderTextArea>
                    </div>

                    <div className="row text-center mt-2 h-100 mr-12">
                      <div className="col h-100 text-center">
                        {values.changePassengerList.filter((x) => x.selected)
                          ?.length > 0 &&
                        // values.remarks?.length > 0 &&
                        values.refundAmount >= 0 &&
                        values.cancellationCharges >= 0 ? (
                          <Button
                            type="submit"
                            disabled={isShow == true ? true : false}
                            style={{ width: "20%", height: "100%" }}
                          >
                            Approve
                          </Button>
                        ) : (
                          <Button
                            // type="submit"
                            style={{ width: "20%", height: "100%" }}
                            disabled
                          >
                            Approve
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </form>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </div>
  );
}
